import { cn } from '@mint-lib/tw-utils';

import { typographyVariants } from './typography.jsx';

function Empty({
  className,
  size = 'big',
  ...props
}: React.ComponentProps<'div'> & { size?: 'big' | 'medium' }) {
  return (
    <div
      data-slot="empty"
      data-size={size}
      className={cn(
        'flex items-center justify-center gap-4 text-center text-balance data-[size="big"]:flex-row data-[size="medium"]:flex-col',
        className,
      )}
      {...props}
    />
  );
}
function EmptyHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="empty-header"
      className={cn('flex flex-col items-center gap-2 text-center', className)}
      {...props}
    />
  );
}

function EmptyContent({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="empty-content"
      className={cn('flex flex-col items-center gap-4 text-center', className)}
      {...props}
    />
  );
}

function EmptyMedia({
  className,
  size = 'big',
  ...props
}: React.ComponentProps<'div'> & { size?: 'big' | 'medium' }) {
  return (
    <div
      data-slot="empty-icon"
      data-size={size}
      className={cn(
        'data-[size="big"]:order-last data-[size="big"]:size-80 data-[size="medium"]:size-40',
        className,
      )}
      {...props}
    />
  );
}

function EmptyTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <h4
      data-slot="empty-title"
      className={cn(
        typographyVariants({ variant: 'h4', color: 'primary' }),
        className,
      )}
      {...props}
    />
  );
}

function EmptyDescription({ className, ...props }: React.ComponentProps<'p'>) {
  return (
    <div
      data-slot="empty-description"
      className={cn(
        typographyVariants({ variant: 'bodyShort01', color: 'primary' }),
        className,
      )}
      {...props}
    />
  );
}

function EmptyActions({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="empty-actions"
      className={cn('flex gap-2', className)}
      {...props}
    />
  );
}

export {
  Empty,
  EmptyContent,
  EmptyHeader,
  EmptyTitle,
  EmptyDescription,
  EmptyActions,
  EmptyMedia,
};
